import script from "./FormWizard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormWizard.vue?vue&type=script&setup=true&lang=ts"

import "./FormWizard.vue?vue&type=style&index=0&id=d30b805a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d30b805a"]])

export default __exports__